import { z } from "zod";

export const activeRulesByCompanyItemSchema = z.object({
  uuid: z.uuid(),
  name: z.string(),
  vehicleCount: z.int(),
  date: z.string(),
});

export const activeRulesByCompanyResponseSchema = z.array(
  activeRulesByCompanyItemSchema,
);

export type ActiveRulesByCompanyItem = z.infer<
  typeof activeRulesByCompanyItemSchema
>;
export type ActiveRulesByCompanyResponse = z.infer<
  typeof activeRulesByCompanyResponseSchema
>;
